if (!customElements.get('sticky-button')) {
  class StickyButton extends HTMLElement {
    constructor() {
      super();
      
      // Configuration
      this.scrollThreshold = 200; // px to scroll before showing sticky
      this.animationDuration = 300; // ms for slide animation
      this.infoWrapper = document.querySelector('.product__info-wrapper');
      
      // State
      this.isSticky = false;
      this.isVisible = false;
      this.originalPosition = null;
      
      // Bind methods
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);

      // Buttons
      this.submitButton = this.querySelector('.product-form__submit');
      this.stickyTarget = this.querySelector('.sticky-target');
      
      // Initialize
      this.init();

      this.stickyTarget.addEventListener('click', (e) => {
        e.preventDefault();
        this.submitButton.click();
      });
    }
    
    init() {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.setup();
        });
      } else {
        this.setup();
      }
    }
    
    setup() {
      // Store original position and styles
      this.storeOriginalState();
      
      // Add event listeners
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });
      
      // Initial check after a short delay to ensure proper positioning
      setTimeout(() => {
        this.handleScroll();
      }, 100);
    }
    
    storeOriginalState() {
      const rect = this.getBoundingClientRect();
      this.originalPosition = {
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        height: rect.height
      };
    }
    
    handleScroll() {
      // Only enable sticky functionality on mobile (below 750px)
      if (window.innerWidth >= 750) {
        // Reset to normal state on desktop
        if (this.isSticky) {
          this.isSticky = false;
          this.updateStickyState();
        }
        return;
      }
      
      const scrollY = window.scrollY;
      const elementTop = this.originalPosition.top;
      const elementBottom = elementTop + this.originalPosition.height;
      const viewportHeight = window.innerHeight;

      let hasScrolledPastThreshold = scrollY >= this.scrollThreshold;
      
      // Check if we've scrolled past the threshold
      if (this.infoWrapper) {
        const infoWrapperHeight = window.innerHeight - (this.infoWrapper.offsetTop - scrollY);
        const twentyPercent = window.innerHeight * 0.2;

        hasScrolledPastThreshold = infoWrapperHeight >= twentyPercent;
      }

      
      // Check if the element is currently in view
      // Element is in view when: scrollY < elementBottom AND scrollY + viewportHeight > elementTop
      const isElementInView = scrollY < elementBottom && scrollY + viewportHeight > elementTop;
      
      // Determine sticky state:
      // - Initially not sticky (before threshold)
      // - After threshold: sticky when element is NOT in view
      let shouldBeSticky = false;
      
      if (hasScrolledPastThreshold) {
        shouldBeSticky = !isElementInView;
      }
      
      // Update sticky state if needed
      if (shouldBeSticky !== this.isSticky) {
        this.isSticky = shouldBeSticky;
        this.updateStickyState();
      }
      
      // Update visibility - show when element is not in view and we've scrolled past threshold
      if (shouldBeSticky !== this.isVisible) {
        this.isVisible = shouldBeSticky;
      }
    }
    
    updateStickyState() {
      if (this.isSticky) {
        this.makeSticky();
      } else {
        this.makeNormal();
      }
    }
    
    makeSticky() {
      // Add sticky class for additional styling
      this.classList.add('sticky-button--sticky');
      this.chatButton = document.querySelector('inbox-online-store-chat');

      if (this.chatButton) {
        this.chatButton.classList.add('sticky');
      }
    }
    
    makeNormal() {
      // Remove sticky class
      this.classList.remove('sticky-button--sticky');
      this.chatButton = document.querySelector('inbox-online-store-chat');
      if (this.chatButton) {
        this.chatButton.classList.remove('sticky');
      }
    }
    
    handleResize() {
      // Recalculate original position on resize
      this.storeOriginalState();
      this.handleScroll();
    }
    
    disconnectedCallback() {
      // Clean up event listeners
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }
  }
  
  customElements.define('sticky-button', StickyButton);
} 